import { type AnyAction, combineReducers } from 'redux';

import type { GenerateRecommendedVideoResponse } from 'js/src/client';
import {
    clearRecommendations,
    setDatasetMetadata,
    setRecommendedVideoResponse,
    setSourceSegmentForRephrasedScene,
} from 'js/src/data/recommendations/recommendations-actions';
import type { DatasetMetadata } from 'js/src/data/recommendations/recommendations-types';
import type { ImmutableMap } from 'js/src/libs/consts';
import { ImmutableFromJS } from 'js/src/libs/consts';

/**
 * For recommended scenes, store the source segment for the scene. This is used to give users a "fallback" option
 * if the text was rephrased or modified from what they expected. For example, the system might be a bit too creative
 * and drop a key detail, so this gives the user a way to get back to the original text.
 */
export function source_segment_per_rephrased_scene(
    state: Record<string, string> = {},
    action: AnyAction,
) {
    if (setSourceSegmentForRephrasedScene.match(action)) {
        return {
            ...state,
            [action.payload.sceneId]: action.payload.sourceSegment,
        };
    }
    if (clearRecommendations.match(action)) {
        return {};
    }
    return state;
}

export function dataset_metadata(state: DatasetMetadata | null = null, action: AnyAction) {
    if (setDatasetMetadata.match(action)) {
        return { ...state, ...action.payload.metadata };
    }
    if (clearRecommendations.match(action)) {
        return null;
    }
    return state;
}

export function recommendedVideoResponse(
    state: ImmutableMap<GenerateRecommendedVideoResponse> | null = null,
    action: AnyAction,
) {
    if (setRecommendedVideoResponse.match(action)) {
        return ImmutableFromJS(action.payload.response);
    }
    if (clearRecommendations.match(action)) {
        return null;
    }
    return state;
}

export const recommendations = combineReducers({
    source_segment_per_rephrased_scene,
    dataset_metadata,
    recommendedVideoResponse,
});

export type RecommendationsState = ReturnType<typeof recommendations>;
